import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { ParkingLotOffer } from '@core/models/promo-code.modal';

@Injectable({
  providedIn: 'root'
})
export class PromoCodeManagementService {

  constructor(private readonly apiService: APIService) { }

createPromoCode(request:ParkingLotOffer){
  return this.apiService.postWithAllResponse('Offer/CreateOffer', request);
}
editOffer(request){
  return this.apiService.postWithAllResponse('Offer/EditOffer',request)
}
getOfferById(offerId){
  return this.apiService.getWithAllResponse(`Offer/GetOfferById?OfferId=${offerId}`);
}
}
